import { DateTime } from 'luxon';
import * as React from 'react';
import { BLOG_CONTEXT } from '@journeyapps/package-blog';
import { normalizeContentModules, normalizePermalink } from '../../shared/content';
import { BlogCategory } from './blogCategories';
export { BLOG_POST_CATEGORIES } from './blogCategories';

export interface BlogPostMeta {
  author: string;
  body_class: string;
  category: BlogCategory | BlogCategory[];
  cover_image: string;
  date: string;
  // Alias for date field
  created?: string;
  description: string;
  layout: string;
  permalink: string;
  // Last time small fixes e.g. typos were made
  revised?: string;
  title: string;
  // Last time core changes were made e.g. new release patch notes.
  // This moves the blog to start of render queue.
  updated?: string;
}

export interface BlogPostModule {
  default: () => React.ReactNode;
  frontmatter: BlogPostMeta;
  tableOfContents?: Array<{
    depth: 2 | 3;
    text: string;
  }>;
}

export interface BlogPost extends BlogPostModule {
  date: DateTime;
  revisedDate?: DateTime;
  sortDate: DateTime;
  updatedDate?: DateTime;
  categories: BlogCategory[];
}

const parseDate = (value?: string): DateTime | undefined => {
  if (!value) {
    return undefined;
  }

  const date = DateTime.fromSQL(value);
  return date.isValid ? date : undefined;
};

const sortMillis = (post: BlogPost): number => {
  return post.sortDate.isValid ? post.sortDate.toMillis() : Number.NEGATIVE_INFINITY;
};

const blogModules = normalizeContentModules(
  BLOG_CONTEXT.keys().map((key) => BLOG_CONTEXT(key) as BlogPostModule) as BlogPostModule[]
);

export { normalizePermalink };

export const BLOG_POSTS = blogModules
  .map((post) => {
    const createdDate =
      parseDate(post.frontmatter.created) ?? parseDate(post.frontmatter.date) ?? DateTime.invalid('Missing date');
    const updatedDate = parseDate(post.frontmatter.updated);

    return {
      ...post,
      categories: Array.isArray(post.frontmatter.category) ? post.frontmatter.category : [post.frontmatter.category],
      date: createdDate,
      revisedDate: parseDate(post.frontmatter.revised),
      sortDate: updatedDate ?? createdDate,
      updatedDate
    } as BlogPost;
  })
  .sort((a, b) => sortMillis(b) - sortMillis(a));
